@if (isAuthorised()) {
  <div>
    <div #trigger="cdkOverlayOrigin" cdkOverlayOrigin class="user-profile">
      @if (isEmployee()) {
        <span class="admin">admin</span>
      } @else {
        @if (isOperator()) {
          <span class="admin">operator</span>
        } @else {
          <div class="user-profile-balance">
            <div class="user-profile-balance__item">
              <span class="user-profile-balance-amount">{{ balance() }}</span>
              <img alt="user-profile" ngSrc="assets/img/icon/coins-gold.svg" height="16" width="16" />
            </div>
            <div class="user-profile-balance__item">
                <span class="user-profile-balance-amount">{{ balanceLPSignal() }}</span>
                <img alt="user-profile" ngSrc="assets/img/icon/lidoma-points.svg" height="16" width="16" />
            </div>
            </div>
          }
        }
        <div
          (click)="switchUserProfileSettingsVisibility()"
          [matRippleCentered]="true"
          class="user-profile-box"
          [ngClass]="{'user-profile-box--active': currentUserExp()}"
          matRipple>
          <img
                [srcset]="
                            avatar() | responseImageSet: 'profile':'avatar'
                        "
            alt="avatar"
            [ngClass]="{'active': currentUserExp()}"
            class="avatar" />
            <div
              class="user-profile-box-badge"
              [ngClass]="{'active': currentUserExp()}">
              {{ currentUserExp() }}
            </div>
          </div>
        </div>
        <ng-template
          (overlayOutsideClick)="switchUserProfileSettingsVisibility()"
          [cdkConnectedOverlayOffsetY]="2"
          [cdkConnectedOverlayOpen]="isOpen()"
          [cdkConnectedOverlayOrigin]="trigger"
          cdkConnectedOverlay>
          <ul class="edit-profile-menu">
            <li (click)="openProfile()" class="edit-profile-menu__item">
              <div class="avatar-container">
                <img
                        [srcset]="
                            avatar() | responseImageSet: 'profile':'avatar'
                        "
                  alt="avatar"
                  class="avatar" />
                </div>
                <div class="profile-nickname">{{ nickname() }}</div>
              </li>
              <!--            <ng-container *ngIf="isPlayer">-->
              @if (isPlayer()) {
                <li
                  (click)="openProfileMyProfile()"
                  [matRippleCentered]="true"
                  class="edit-profile-menu__item"
                  matRipple>
                  <img
                    alt="profile info"
                    class="icon"
                    src="assets/img/icon/ghost-icon.svg" />
                    <span class="icon-text">
                      {{ 'myProfile' | translate }}
                    </span>
                  </li>
                  <li
                    (click)="openProfileMyTeams()"
                    [matRippleCentered]="true"
                    class="edit-profile-menu__item"
                    matRipple>
                    <img
                      alt="profile info"
                      class="icon"
                      src="assets/img/icon/team-icon.svg" />
                      <span class="icon-text">
                        {{ 'myTeams' | translate }}
                      </span>
                    </li>
                    <li
                      (click)="openProfileMyTournaments()"
                      [matRippleCentered]="true"
                      class="edit-profile-menu__item"
                      matRipple>
                      <img
                        alt="profile info"
                        class="icon"
                        src="assets/img/icon/cup-icon.svg" />
                        <span class="icon-text">
                          {{ 'myTournaments' | translate }}
                        </span>
                      </li>
                      <li
                        (click)="openProfileWallet()"
                        [matRippleCentered]="true"
                        class="edit-profile-menu__item"
                        matRipple>
                        <img
                          alt="profile info"
                          class="icon"
                          src="assets/img/icon/wallet-icon.svg" />
                          <span class="icon-text">
                            {{ 'profileWallet' | translate }}
                          </span>
                        </li>
                      }
                      <li
                        (click)="openProfileSettings()"
                        [matRippleCentered]="true"
                        class="edit-profile-menu__item edit-profile-menu__item--separated"
                        matRipple>
                        <img
                          alt="profile settings"
                          class="icon"
                          src="assets/img/icon/cog-icon.svg" />
                          <span class="icon-text">
                            {{ 'profileSettings' | translate }}
                          </span>
                        </li>
                        <!--            <li-->
                        <!--                (click)="buyPremiumModal()"-->
                        <!--                [matRippleCentered]="true"-->
                        <!--                class="edit-profile-menu__item"-->
                        <!--                matRipple>-->
                        <!--                <img-->
                        <!--                    alt="buy premium"-->
                        <!--                    class="icon"-->
                        <!--                    src="assets/img/icon/coins-silver.svg" />-->
                        <!--                <span class="icon-text">-->
                        <!--                    {{ 'become_premium' | translate }}-->
                      <!--                </span>-->
                    <!--            </li>-->
                    <li
                      (click)="logOut()"
                      [matRippleCentered]="true"
                      class="edit-profile-menu__item edit-profile-menu__item--accent"
                      matRipple>
                      <svg-icon src="assets/img/icon/door-icon.svg"  [svgStyle]="{'width.px': 20,'height.px': 20, 'fill':'#FF4647' }"></svg-icon>
                      <span class="icon-text">
                        {{ 'logout' | translate }}
                      </span>
                    </li>
                  </ul>
                </ng-template>
              </div>
            }
